export enum TableCellAlignments {
    Left = "left",
    Center = "center",
    Right = "right",
}
